var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "simple-row" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "a",
            {
              staticClass: "swb-btn swb-btn-small",
              on: { click: _vm.toPrint }
            },
            [_vm._v("打印")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("调拨信息")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showTransVoucherInfoFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowTransVoucherInfo()
              }
            }
          },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.showTransVoucherInfoFlag ? "隐藏" : "展开"))
            ]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showTransVoucherInfoFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showTransVoucherInfoFlag
        ? [
            _c("div", { staticClass: "simple-form flex col-4" }, [
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _vm.transVoucherInfo.srcVoucherType != null
                      ? _c("el-tag", { attrs: { type: "danger" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.voucherTypeMap[
                                _vm.transVoucherInfo.srcVoucherType
                              ]
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.transVoucherInfo.innerNo || "无"))
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.transVoucherInfo.totalQuantity))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        parseFloat(
                          _vm.transVoucherInfo.totalNetWorth || 0
                        ).toFixed(2)
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.transVoucherInfo.creatorComName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.transVoucherInfo.applicantName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.transVoucherInfo.applicantContactTel || "无")
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._m(6),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.transVoucherInfo.srcComFullName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(8),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.transVoucherInfo.srcBizUnitCode || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(9),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.transVoucherInfo.srcCostCenterCode || "无")
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(10),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.transVoucherInfo.srcPrftCenterCode || "无")
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(11),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.transVoucherInfo.dstComFullName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(12),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.transVoucherInfo.dstBizUnitCode || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(13),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.transVoucherInfo.dstCostCenterCode || "无")
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(14),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.transVoucherInfo.dstPrftCenterCode || "无")
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(15),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.transVoucherInfo.createTime || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(16),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.transVoucherInfo.applyTime || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._m(17),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(18),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.transVoucherInfo.applyDesc || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(19),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.transVoucherInfo.memo || "无"))
                  ])
                ])
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.transVoucherInfo.assetType != 2 ? "资产信息" : "耗材信息"
            )
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showDeviceItemFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowDeviceItem()
              }
            }
          },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.showDeviceItemFlag ? "隐藏" : "展开"))
            ]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showDeviceItemFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showDeviceItemFlag
        ? [
            !_vm.transVoucherInfo.suitFlag
              ? _c("div", [
                  _vm.deviceItemList != null && _vm.deviceItemList.length > 0
                    ? _c(
                        "div",
                        { staticClass: "table-layout" },
                        [
                          _c(
                            "el-table",
                            {
                              ref: "multipleTable",
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.deviceItemList,
                                border: "",
                                "tooltip-effect": "dark",
                                maxHeight: "500"
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  align: "left",
                                  prop: "innerCode",
                                  "min-width": "200",
                                  label: "资产编号",
                                  fixed: "",
                                  "show-overflow-tooltip": ""
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "table-cell-link",
                                            on: {
                                              click: function($event) {
                                                _vm.viewAssetInfo(
                                                  rows.row.innerCode,
                                                  rows.row.assetType
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(rows.row.innerCode))]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  align: "left",
                                  prop: "title",
                                  label: "资产描述全称",
                                  width: "200",
                                  fixed: "",
                                  "show-overflow-tooltip": ""
                                }
                              }),
                              _vm._v(" "),
                              _vm.transVoucherInfo.receiptState == 1 ||
                              _vm.transVoucherInfo.receiptState == 2
                                ? _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      prop: "initInnerCode",
                                      label: "原始资产编号",
                                      width: "200",
                                      "show-overflow-tooltip": ""
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "vendorUkno",
                                  label: "商品标识码",
                                  width: "180",
                                  align: "left"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  align: "right",
                                  prop: "quantity",
                                  width: "100",
                                  label: "调拨数量"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "控制方式",
                                  align: "center",
                                  width: "80"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.splitible
                                                ? "按金额"
                                                : "按数量"
                                            )
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  align: "right",
                                  prop: "splittedAmount",
                                  width: "100",
                                  label: "调拨原值(元)"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        rows.row.splittedAmount != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  rows.row.splittedAmount.toFixed(
                                                    2
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  align: "right",
                                  prop: "orgWorth",
                                  width: "80",
                                  label: "资产原值(元)"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        rows.row.assetOrgWorth != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  rows.row.assetOrgWorth.toFixed(
                                                    2
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  align: "right",
                                  prop: "orgWorth",
                                  width: "80",
                                  label: "调入原值(元)"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        rows.row.orgWorth2 != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  rows.row.orgWorth2.toFixed(2)
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  align: "right",
                                  prop: "netWorth",
                                  width: "80",
                                  label: "调入净值(元)"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        rows.row.netWorth2 != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  rows.row.netWorth2.toFixed(2)
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "dstComFullName",
                                  label: "调入机构",
                                  width: "300",
                                  "show-overflow-tooltip": ""
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        scope.row.dstMerchantId !=
                                          scope.row.retailerId &&
                                        scope.row.dstMerchantName != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.dstMerchantName
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.dstMerchantId !=
                                          scope.row.retailerId &&
                                        scope.row.dstMerchantName != null &&
                                        scope.row.dstComFullName != null
                                          ? _c("span", [_vm._v("/")])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.dstComFullName != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(scope.row.dstComFullName)
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "innerNo",
                                  label: "外部资产编码",
                                  width: "180",
                                  align: "left"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "dstComNo",
                                  label: "调入机构编号",
                                  width: "120"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "dstCostCenterCode",
                                  label: "调入成本中心",
                                  width: "160"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "srcComFullName",
                                  label: "调出机构",
                                  width: "140",
                                  "show-overflow-tooltip": ""
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "srcRealComCode",
                                  label: "调出公司编码",
                                  width: "160"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "srcCostCenterCode",
                                  label: "调出成本中心",
                                  width: "160"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  align: "left",
                                  prop: "fixedSpec",
                                  label: "规格",
                                  width: "150",
                                  "show-overflow-tooltip": ""
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  prop: "theUnit",
                                  "min-width": "50",
                                  label: "单位"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  align: "left",
                                  prop: "assetNature",
                                  label: "资产属性",
                                  "show-overflow-tooltip": ""
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.assetNatureMap[
                                                rows.row.assetNature
                                              ]
                                            )
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  prop: "fiscalAcctFlag",
                                  width: "100",
                                  label: "是否在账"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              rows.row.fiscalAcctFlag
                                                ? "是"
                                                : "否"
                                            )
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  align: "right",
                                  prop: "quantity2",
                                  width: "100",
                                  label: "含报废数量"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(rows.row.quantity2 || 0)
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  align: "left",
                                  prop: "dstInnerCode",
                                  "min-width": "200",
                                  label: "调入资产编号"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return _vm._l(
                                        rows.row.dstInnerCodeList,
                                        function(dstInnerCode) {
                                          return _c(
                                            "a",
                                            {
                                              staticClass: "table-cell-link",
                                              on: {
                                                click: function($event) {
                                                  _vm.viewAssetInfo(
                                                    dstInnerCode,
                                                    rows.row.assetType
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(dstInnerCode))]
                                          )
                                        }
                                      )
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  align: "right",
                                  prop: "aggtDeprWorth",
                                  width: "100",
                                  label: "调入累计折旧(元)"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        rows.row.aggtDeprWorth2 != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  rows.row.aggtDeprWorth2.toFixed(
                                                    2
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  align: "right",
                                  prop: "taxRate",
                                  width: "80",
                                  label: "税率(%)"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        rows.row.taxRate != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  rows.row.taxRate.toFixed(2)
                                                )
                                              )
                                            ])
                                          : _c("span", [_vm._v("0")])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  align: "left",
                                  prop: "memo",
                                  "min-width": "100",
                                  label: "备注",
                                  "show-overflow-tooltip": ""
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  align: "left",
                                  prop: "tmpNo",
                                  width: "250",
                                  label: "系统编号"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "assetType",
                                  width: "100",
                                  label: "管理方式",
                                  align: "center"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.assetTypeMap[
                                                rows.row.assetType
                                              ]
                                            )
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.colNames, function(colNameX) {
                                return [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: colNameX,
                                      align: "center",
                                      width: "200",
                                      "show-overflow-tooltip": ""
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _vm._l(
                                              scope.row.reservedNoJson,
                                              function(theJson) {
                                                return scope.row
                                                  .reservedNoJson != null
                                                  ? [
                                                      theJson.text == colNameX
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                theJson.value
                                                              )
                                                            )
                                                          ])
                                                        : _vm._e()
                                                    ]
                                                  : _vm._e()
                                              }
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ]
                              }),
                              _vm._v(" "),
                              _vm.devcCustTag1.enabled == true
                                ? _c("el-table-column", {
                                    attrs: {
                                      prop: "devcCustTag1Val",
                                      label: _vm.devcCustTag1.dispName,
                                      width: "120"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.devcCustTag2.enabled == true
                                ? _c("el-table-column", {
                                    attrs: {
                                      prop: "devcCustTag2Val",
                                      label: _vm.devcCustTag2.dispName,
                                      width: "120"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.devcCustTag3.enabled == true
                                ? _c("el-table-column", {
                                    attrs: {
                                      prop: "devcCustTag3Val",
                                      label: _vm.devcCustTag3.dispName,
                                      width: "120"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  align: "left",
                                  width: "120",
                                  label: "操作"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "swb-btn swb-btn-link",
                                            on: {
                                              click: function($event) {
                                                _vm.changeInfo(
                                                  rows.row.innerCode
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("调拨变动详情")]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pagination-layout" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          background: "",
                          "page-size": _vm.pageSize,
                          "page-sizes": _vm.pageSizes,
                          "current-page": _vm.pageNumber,
                          total: _vm.totalCount,
                          layout: "total, sizes, prev, pager, next, jumper"
                        },
                        on: {
                          "current-change": _vm.handlePageChange,
                          "size-change": _vm.handleSizeChange
                        }
                      })
                    ],
                    1
                  )
                ])
              : _c(
                  "div",
                  { staticClass: "table-layout" },
                  [
                    _c(
                      "el-table",
                      { attrs: { data: _vm.deviceItemList, border: "" } },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "innerCode",
                            "min-width": "250",
                            fixed: "",
                            label: "资产编号",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "table-cell-link",
                                      on: {
                                        click: function($event) {
                                          _vm.viewAssetInfo(
                                            rows.row.innerCode,
                                            rows.row.assetType
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(rows.row.innerCode))]
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "title",
                            label: "设备名称",
                            align: "left",
                            width: "150",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "vendorUkno",
                            label: "商品标识码",
                            width: "180",
                            align: "left"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "tmpNo",
                            label: "系统编号",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "是否主资产",
                            align: "center",
                            width: "100"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.suitMainFlag
                                    ? _c(
                                        "span",
                                        { staticClass: "font-green" },
                                        [_vm._v("是")]
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "suitNo",
                            label: "套装编号",
                            align: "center",
                            width: "200"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "catName",
                            label: "设备分类",
                            width: "150",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "groupName",
                            label: "维保分组",
                            width: "120",
                            align: "left",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getGoodsCatDevcGroupName(
                                          rows.row.catId
                                        )
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "brandName",
                            label: "设备品牌",
                            width: "150",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "modelSpec",
                            label: "设备规格",
                            width: "150",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "srcComName",
                            width: "100",
                            label: "调出部门"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "srcWarehouseName",
                            width: "100",
                            label: "调出仓库"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "dstComName",
                            width: "100",
                            label: "调入部门"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "dstWarehouseName",
                            width: "100",
                            label: "调入仓库"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.shopDeviceTransFileList != null &&
      _vm.shopDeviceTransFileList.length > 0
        ? _c(
            "div",
            [
              _c("div", { staticClass: "content-caption dashed" }, [
                _c("span", [_vm._v("附件信息")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "shrink-tab fr",
                    class: _vm.showShopDeviceTransFlag ? "current" : "",
                    on: {
                      click: function($event) {
                        _vm.doShowShopDeviceTrans()
                      }
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.showShopDeviceTransFlag ? "隐藏" : "展开")
                      )
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      class: _vm.showShopDeviceTransFlag
                        ? "el-icon-arrow-down"
                        : "el-icon-arrow-right"
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.showShopDeviceTransFlag
                ? [
                    _c(
                      "div",
                      { staticClass: "file-view-list" },
                      [
                        _vm._m(20),
                        _vm._v(" "),
                        _vm._l(_vm.shopDeviceTransFileList, function(
                          fileInfo,
                          index
                        ) {
                          return [
                            _c("swb-file-item-li", {
                              attrs: {
                                trackKey: index,
                                fileName: fileInfo.name,
                                fileBrowseUrl: fileInfo.fileBrowseUrl,
                                fileDownloadUrl: fileInfo.fileBrowseUrl,
                                fileUuid: fileInfo.fileUuid,
                                deletable: false
                              }
                            })
                          ]
                        })
                      ],
                      2
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.transVoucherInfo.outerAuditFlag &&
      _vm.transVoucherInfo.applyState != 0 &&
      _vm.checkActionPerm("audit_rec") &&
      _vm.recList.length > 0
        ? [
            _c("div", { staticClass: "content-caption dashed" }, [
              _c("span", [_vm._v("审核记录")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "shrink-tab fr",
                  class: _vm.showOaAuditFlag ? "current" : "",
                  on: {
                    click: function($event) {
                      _vm.doShowOaAuditInfo()
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.showOaAuditFlag ? "隐藏" : "展开"))
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    class: _vm.showOaAuditFlag
                      ? "el-icon-arrow-down"
                      : "el-icon-arrow-right"
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm.showOaAuditFlag
              ? [
                  _c("swb-oa-audit-rec-list", {
                    ref: "swb_oa_audit_rec_list",
                    attrs: {
                      bizTypeCode: "retailer.assets.allot",
                      bizVoucherNo: _vm.transVoucherInfo.innerNo,
                      auditSeqNo: _vm.transVoucherInfo.auditSeqNo
                    }
                  })
                ]
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.transVoucherInfo.outerAuditFlag &&
      _vm.checkActionPerm("view_rec") &&
      _vm.transVoucherInfo.no != null
        ? [
            _c("div", { staticClass: "content-caption dashed bg-white" }, [
              _c("span", [_vm._v("审核记录")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "shrink-tab fr",
                  class: _vm.showDeviceActFlag ? "current" : "",
                  on: {
                    click: function($event) {
                      _vm.doShowDeviceActInfo()
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.showDeviceActFlag ? "隐藏" : "展开"))
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    class: _vm.showDeviceActFlag
                      ? "el-icon-arrow-down"
                      : "el-icon-arrow-right"
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm.showDeviceActFlag
              ? [
                  _c("swb-shop-device-act-rec-list", {
                    ref: "swb_shop_device_act_rec_list",
                    attrs: {
                      showQuery: false,
                      showComFlag: true,
                      srcVoucherNo: _vm.transVoucherInfo.no,
                      srcVoucherType: 3
                    }
                  })
                ]
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调拨单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调拨总数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调拨总金额")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建机构")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请人电话")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "form-label" }, [_c("label")]),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [_c("span")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调出机构")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调出机构编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调出成本中心")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调出利润中心")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调入机构")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调入机构编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调入成本中心")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调入利润中心")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调拨日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "form-label" }, [_c("label")]),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [_c("span")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请原因")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("标题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "file-view-header" }, [
      _c("div", { staticClass: "file-name" }, [_vm._v("名称")]),
      _vm._v(" "),
      _c("div", { staticClass: "file-opera" }, [_vm._v("操作")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46d1d2b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46d1d2b8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/tranVoucherDevc/ShopDeviceTransVoucherView.vue
// module id = 2588
// module chunks = 0